function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M360.613 283.333c0 10.349-8.402 18.75-18.75 18.75-10.349 0-18.75-8.401-18.75-18.75 0-10.348 8.401-18.75 18.75-18.75 10.348 0 18.75 8.402 18.75 18.75z",
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 4.17
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.292 193.244s-166.687 88.195 23.975 81.373c222.8-7.971 567.171-173.187 324.859-176.88",
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 4.17,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M177.279 125c0 10.348-8.401 18.75-18.75 18.75-10.348 0-18.75-8.402-18.75-18.75s8.402-18.75 18.75-18.75c10.349 0 18.75 8.402 18.75 18.75z",
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 4.17
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 267.708,
  cy: 187.5,
  r: 185.417,
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 4.17,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M377.279 100c0 19.547-15.87 35.417-35.416 35.417-19.547 0-35.417-15.87-35.417-35.417 0-19.547 15.87-35.417 35.417-35.417 19.546 0 35.416 15.87 35.416 35.417z",
  fill: "none",
  stroke: "#3c00dc",
  strokeWidth: 4.17
});

function SvgPlanetinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 536 375",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgPlanetinline;